angular.module('services.endpoints.RelativesService', [
  'global'
])

/**
 * The RelativesService service stores relatives of an
 * API isntance
 *
 * @class RelativesService
 * @constructor
 * @module services.endpoints.RelativesService
 */
.factory('RelativesService', [
  'ModelsService',
  'EndpointsService',
  function (ModelsService, EndpointsService) {
    'use strict';

    var service = {
      relativesEdit: null,

      /**
       * Returns the content creation object
       *
       * @return {Object} Content creation object
       */
      getRelativesEdit: function getRelativesEdit() {
        if (EndpointsService.current.instance) {
          service.relativesEdit = service.setRelativesEdit();
        }
        return service.relativesEdit;
      },

      /**
       * Sets the relativesEdit Object based on the
       * current endpoint
       *
       * @return {Object} relatives
       */
      setRelativesEdit: function setRelativesEdit() {
        var schema = ModelsService.find('schemas', 'label', 'relatives');
        var relativesEdit = {};

        relativesEdit.schema = schema.content.schema;
        relativesEdit.form = schema.content.form;
        relativesEdit.model = { relatives: _.clone(EndpointsService.current.instance.relatives) };

        console.log('setRelativesEdit: relativesEdit', relativesEdit);
        return relativesEdit;
      },

      /**
       * Formats and saves relative edit data on an instance
       *
       * @param {Object} relative - Relatives data to update on endpoint
       * @param {string} schema - Schema used to validate the content
       * @param {Object} instance - Instance to update
       * @return {Promise<Object>} instance with updated relatives
       */
      saveRelativesEditData: function saveRelativesEditData(relative, schema, instance) {
        var data = {};

        data.relatives = relative.relatives;
        data.schema = schema;

        console.log('RelativesService: saveContentCreateData: data', data);
        return ModelsService.update(instance, data);
      }

    };

    return service;
  }
]);
